import React from "react"

export const YouTubeIcon = ({ height = 16, width = 16, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M5.66634 3.00008L9.12634 5.00008L5.66634 7.00008V3.00008ZM13.373 8.22008C13.4597 7.90675 13.5197 7.48675 13.5597 6.95341C13.6063 6.42008 13.6263 5.96008 13.6263 5.56008L13.6663 5.00008C13.6663 3.54008 13.5597 2.46675 13.373 1.78008C13.2063 1.18008 12.8197 0.793415 12.2197 0.626748C11.9063 0.540081 11.333 0.480081 10.453 0.440081C9.58634 0.393414 8.79301 0.373414 8.05967 0.373414L6.99967 0.333414C4.20634 0.333414 2.46634 0.440082 1.77967 0.626748C1.17967 0.793415 0.793008 1.18008 0.626341 1.78008C0.539675 2.09341 0.479675 2.51341 0.439675 3.04675C0.393008 3.58008 0.373008 4.04008 0.373008 4.44008L0.333008 5.00008C0.333008 6.46008 0.439675 7.53341 0.626341 8.22008C0.793008 8.82008 1.17967 9.20675 1.77967 9.37341C2.09301 9.46008 2.66634 9.52008 3.54634 9.56008C4.41301 9.60675 5.20634 9.62675 5.93967 9.62675L6.99967 9.66675C9.79301 9.66675 11.533 9.56008 12.2197 9.37341C12.8197 9.20675 13.2063 8.82008 13.373 8.22008Z"
        fill="currentColor"
      />
    </svg>
  )
}
